import React from 'react'
import './Cards.css'

function Card() {
    return (

        <div></div>

    )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Part2/Card/Card.js